import React from 'react';
import "./Header.css"
import Typical from 'react-typical';
const Header = () => {
  return (
    <div className='header-container'>
        <div className='header-content'>
            <h1>Hello!</h1>
            <h2 className='name'>I am Swarali!</h2>
            <h2>I'm a{" "}
                <Typical
                steps={[
                  "Full Stack Web Developer✅", 2000,
                  "Data Science Enthusiast📈",2000,
                  
                    "Machine Learning Enthusiast🚀", 2000,
                    "Cloud Computing Enthusiast💻",2000,
                ]} loop={Infinity} wrapper='b'
                />
            </h2>
                <p>"I am a passionate tech enthusiast who thrives on engaging in diverse projects. My focus lies in leveraging technology to solve real-world challenges creatively. I particularly enjoy delving into problem-solving using Data Structures and Algorithms, with Java as my tool of choice." </p>
                <button className='btn'
        role="link"
        onClick={() => window.open("https://contactformportfolio.netlify.app")}
      >
        Contact Me
      </button>
        </div>     
    </div>
  );
};

export default Header;